<template>
    <div>
        <div @click="downloadFile">ascascasc</div>
        <br>
        <div @click="d2">ascascasajscdhjaschkjascksc</div>
        <br>
        <div @click="d3">dfdjhfkjfhejf</div>
        <iframe id="Iframe" style="width:1300px;height:500px;display:none;" :src="pdfUrl + '#toolbar=0'" frameborder="0"></iframe>
    </div>
    
</template>

<script>

    import axios from 'axios';

    export default {
        data(){
            return{
                pdfUrl : '',
                blob : ''
            }
        },
        methods:{
            downloadFile(){
                let _this = this;
                axios({
                    method: 'GET',
                    url:'https://hk.qmisit.com:3785/admin/getKHPdfData?id=2011012',
                    responseType: 'blob'
                }).then((res) => {
                    let blob = new Blob([res.data], { type: 'application/pdf' });
                    _this.blob = blob;
                    console.log(blob)
                    let b = window.URL.createObjectURL(blob); 
                    console.log(b)
                    _this.pdfUrl = b;
                })
            },
            d2(){
                const printIframe = document.getElementById("Iframe");
                let frameWindow = printIframe.contentWindow;
                setTimeout(()=>{
                    frameWindow.print();
                },2000);
            },   
            d3(){
                let _this = this;
                const printIframe = document.getElementById("Iframe");
                printIframe.contentWindow.print();
                setTimeout(()=>{
                    window.URL.revokeObjectURL(_this.blob);
                },500);
            }   
        },
    } 


</script>
